export default __webpack_public_path__ + "static/media/android-s1.9fd57e83.webp";